// @flow
import * as React from 'react';

import styles from './Breadcrumb.module.scss';;


type Props = {
  children: React.Node,
}

const Breadcrumb = ({ children }: Props) => (
  <nav aria-label="breadcrumb" className={styles.root}>
    {children}
  </nav>
);

export default Breadcrumb;
